/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('./../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

// Set true for app localized.
const defaultLocale = 'en';
const locales = ['en'];

// The format map provides an ability to separate locales from the format of dates.
// An important note is that messages is the language that will be sent to the backend as the language to get data
// LocaleFormat is what will be configured in react-intl for number and date formats.
// The messages (texts in the website) will be based on messages information, so if the user visits in this case "en"
// he would see number formatted in "en" (but it could be configured for de or pt).
// Each of the keys in the mapping will be sent to nextJs as the allowed locale.
// const formatMap = {
//   [defaultLocale]: {
//     messages: defaultLocale,
//     localeFormat: defaultRegion,
//   },
// };
const formatMap = {};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    TURBOPACK_BUILD: true,
    LOCALES: locales,
    DEFAULT_LOCALE: defaultLocale,
    FORMAT_MAP: formatMap,
    SITENAME: 'Workplace Diversity',
    SITE_DESCRIPTION: 'WorkplaceDiversity.com, is a premier job board site for employers who are seeking experienced diverse talent.',
    FRONTENDS: {
      default: 'workplacediversity',
      diversityineducation: 'diversityineducation',
      blackjobcenter: 'blackjobcenter',
      latinxjobs: 'latinxjobs',
      disabilityconnect: 'disabilityconnect',
      lgbtconnect: 'lgbtconnect',
      veteransconnect: 'veteransconnect',
      womensjobcenter: 'womensjobcenter',
      outandequal: 'outandequal',
      diversityconnect: 'diversityconnect',
      hispanicdiversity: 'hispanicdiversity',
      alldiversity: 'alldiversity',
      veteransjobline: 'veteransjobline',
      diversityjobline: 'diversityjobline',
      lgbtqjobline: 'lgbtqjobline',
      latinxjobline: 'latinxjobline',
      womensjobline: 'womensjobline',
      militaryvetjobs: 'militaryvetjobs',
      diversityinhighereducation: 'diversityinhighereducation',
      higheredjobline: 'higheredjobline',
      healthcare: 'healthcare',
    },
    SHARING_BUTTONS_ENABLED: ['facebook', 'linkedin', 'email', 'twitter', 'whatsapp'],
    SOCIAL_LINKS: {
      linkedin: 'https://www.linkedin.com/company/workplacediversitycom',
    },
    PRICE_CONFIG: {
      CURRENCY_PLACEMENT: 'before',
      USE_SPACING: false,
    },
    SUBSCRIPTIONS_FEATURE_ACTIVE: true,
    LINKEDIN_OAUTH_FEATURE_ACTIVE: true,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: false,
    GOOGLE_OAUTH_FEATURE_ACTIVE: true,
    NEWSLETTER_FEATURE_ACTIVE: true,
    SHOW_GA4_STATISTICS: false,
    THEME: {
      colors: {
        primary: '#1663e7'
      },
    },
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      location: { lat: 39.810106, lng: -98.557822 },
      radius: 500,
    },
    GTM_CONTAINER_ID: 'GTM-MN34CHNQ',
    GTM_SCRIPT_STRATEGY: 'afterInteractive',
    GA4_MEASUREMENT_IDS: ['G-SF83156H8J', 'G-QB133P1TLC'],
    PRIVACY_LINK: 'https://www.workplacediversity.com/privacy-policy',
    EURO_VAT_SYSTEM: false,
  },
});
